import { withAuth } from '@utilities/queries';
import { getDashboardRecentlyViewed } from '@simplywallst/services';
import type { Company } from '@simplywallst/services/lib/endpoints/getDashboardRecentlyViewed';

export default async function queryFn(): Promise<Company[] | undefined> {
  try {
    const response = await withAuth(getDashboardRecentlyViewed);
    const { data } = response.data;
    return data;
  } catch (error: any) {
    console.log(error.message);
  }
}
